import { gql } from "@apollo/client";

export const CREATE_PLAYLIST = gql`
  mutation CreatePlaylist($name: String!, $type: PlaylistType!) {
    createPlaylist(name: $name, type: $type) {
      id
    }
  }
`;
